module.exports = __webpack_public_path__ + "d9fee0d49198a326d90fcf2a682da3a3.svg";